import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=00874b22&"
import script from "./tips.vue?vue&type=script&lang=ts&"
export * from "./tips.vue?vue&type=script&lang=ts&"
import style0 from "./tips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports